import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUsersViewfinder, FaFilePen } from "react-icons/fa6";
import Grid from "@mui/material/Grid";
import Templete from "../../template/Template";
import ButtonCard from "../../components/ButtonCard/ButonCard";
import Paragrafos from "./Paragrafos";
import { isPermite } from "../../utilities/isPermite";

export default function Cadastros() {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);

    return (
        <Templete menuActive="cadastros">
            <Paragrafos
                openModal={openModal}
                setOpenModal={setOpenModal}
            />
            <Grid container spacing={1}>
                <Grid item xs={12} sm={3}>
                    <ButtonCard
                        icon={<FaUsersViewfinder size={55} />}
                        title="PARCEIROS"
                        handle={() => navigate("/corretores")}
                    />
                </Grid>
                {isPermite("44") && (
                    <Grid item xs={12} sm={3}>
                        <ButtonCard
                            icon={<FaFilePen size={55} />}
                            title="PARAGRAFOS"
                            handle={() => setOpenModal(true)}
                        />
                    </Grid>
                )}
            </Grid>
        </Templete>
    );
}